module.exports = __webpack_public_path__ + "static/img/land-item.5cb647b1.png";